import { render, staticRenderFns } from "./AdminUserGamesElement.vue?vue&type=template&id=7f6c86dd&scoped=true"
import script from "./AdminUserGamesElement.vue?vue&type=script&lang=js"
export * from "./AdminUserGamesElement.vue?vue&type=script&lang=js"
import style0 from "./AdminUserGamesElement.vue?vue&type=style&index=0&id=7f6c86dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6c86dd",
  null
  
)

export default component.exports